import { render, staticRenderFns } from "./EditorMapa.vue?vue&type=template&id=5e256ec4"
import script from "./EditorMapa.vue?vue&type=script&lang=js"
export * from "./EditorMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports